/** Shopify CDN: Minification failed

Line 31:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 33:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 35:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 41:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 45:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 21:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 23:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 23:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 25:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 31:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 35:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 11:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 13:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 13:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 15:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 21:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 25:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
(async () => {

    const { Core } = await importModule('Core');

    customElements.define('lights-out', class extends Core {
        
        subscriptions = {
            'lights-out':  '_handleLights'
        }
        
        render() {
            this.subscribe('lights-out', { global: true });
        }

        _handleLights(state) {
            this.on = state
        }

        set on(state) {
            clearTimeout(this.timeout)
            if(state) {
                this.setAttribute('on', '');
                return;
            }
            this.timeout = setTimeout(() => this.removeAttribute('on'), 175);
        }
    });

})();